import axiosInstance from './axios';

const waitGrecaptcha = () =>
  new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      setTimeout(() => {
        waitGrecaptcha().then(resolve);
      }, 100);
    } else {
      resolve(window);
    }
  });

export const refreshRecaptcha = async (): Promise<string> => {
  if (!window.grecaptcha) {
    await waitGrecaptcha();
  }

  const grecaptcha = window.grecaptcha!;

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action: 'submit' })
        .then((token) => {
          axiosInstance.defaults.headers.common['X-Recaptcha-Token'] = token;
          resolve(token);
        });
    });
  });
};
